const BASE = '/v1/step-execution';

export default (instance) => ({
  getQueue: (stationTypeId) => instance.get(`${BASE}/queue/${stationTypeId}`),
  getMyQueue: () => instance.get(`${BASE}/my-queue`),
  getAvailableStations: (routeStepId) => instance.get(`${BASE}/available-stations`, { params: { routeStepId } }),
  startStep: (wipItemId, data) => instance.post(`${BASE}/start/${wipItemId}`, data),
  completeStep: (executionId, data) => instance.post(`${BASE}/complete/${executionId}`, data),
  failStep: (executionId, data) => instance.post(`${BASE}/fail/${executionId}`, data),
  getReservedMaterials: (executionId) => instance.get(`${BASE}/reserved-materials/${executionId}`),
  getHistory: (wipItemId) => instance.get(`${BASE}/history/${wipItemId}`),
  getProcessingInfo: (executionId) => instance.get(`${BASE}/processing-info/${executionId}`),
  completeProcessingStep: (executionId, data) => instance.post(`${BASE}/complete-processing/${executionId}`, data),
  getMyActive: () => instance.get(`${BASE}/my-active`),
  getMaterials: (executionId) => instance.get(`${BASE}/${executionId}/materials`),
  getPendingMaterials: (routeStepId, warehouseId) => instance.get(`${BASE}/route-step/${routeStepId}/materials`, { params: { warehouseId } }),
  getProductionPlanInfo: (wipItemId, routeStepId) => instance.get(`${BASE}/production-plan-info/${wipItemId}/${routeStepId}`),
  getQaHold: (wipItemId) => instance.get(`${BASE}/qa-hold/${wipItemId}`),
  reworkPredecessors: (wipItemId, routeStepId) => instance.post(`${BASE}/rework/${wipItemId}/${routeStepId}`)
});
